$(document).ready(function () {

    var btn = document.getElementById('download'),
        share_btn = document.getElementById('shareFB'),
        svg = document.querySelector('svg'),
        canvas = document.querySelector('canvas');

    btn.addEventListener('click', function () {
        var canvas = document.getElementById('canvas');
        var ctx = canvas.getContext('2d');
        var data = (new XMLSerializer()).serializeToString(svg);
        var DOMURL = window.URL || window.webkitURL || window;

        var img = new Image();
        var svgBlob = new Blob([data], {
            type: 'image/svg+xml;charset=utf-8'
        });
        var url = DOMURL.createObjectURL(svgBlob);

        img.onload = function () {
            ctx.drawImage(img, 0, 0);
            DOMURL.revokeObjectURL(url);

            var imgURI = canvas
                .toDataURL('image/png')
                .replace('image/png', 'image/octet-stream');

            triggerDownload(imgURI);
        };

        img.src = url;
    });

    share_btn.addEventListener('click', function () {
        var canvas = document.getElementById('canvas');
        var ctx = canvas.getContext('2d');
        var data = (new XMLSerializer()).serializeToString(svg);
        var DOMURL = window.URL || window.webkitURL || window;

        var img = new Image();
        var svgBlob = new Blob([data], {
            type: 'image/svg+xml;charset=utf-8'
        });
        var url = DOMURL.createObjectURL(svgBlob);

        img.onload = function () {
            ctx.drawImage(img, 0, 0);
            DOMURL.revokeObjectURL(url);

            var imgURI = canvas
                .toDataURL('image/png')
                .replace('image/png', 'image/octet-stream');

            //triggerDownload(imgURI);
            uploadEx();
        };

        img.src = url;

    });

    $('#color-picker').spectrum({
        type: "flat",
        showPaletteOnly: "true",
        showInput: "false",
        showInitial: "true",
        hideAfterPaletteSelect: "true",
        palette: [
            ['#C11111', '#D70465', '#f091a7', '#F8C7D7', '#FDE3D8'],
            ['#8DCFF0', '#018E3B', '#94C11F', '#FFDD00', '#faaf16'],
            ['#FFFFFF']
        ],
        change: function (color) {
            console.log(color.toHex());
            if (color.toHex() != "ffffff") {
                var fill = " fill='%23" + color.toHex() + "'";
                $('#Layer_1').css('cursor', 'url("data:image/svg+xml,%3Csvg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' x=\'0px\' y=\'0px\' width=\'20px\' height=\'20px\' viewBox=\'0 0 512 512\'%3E%3Cpath ' + fill + ' d=\'M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z\'%3E%3C/path%3E%3C/svg%3E") 0 20, pointer');
            } else {
                $('#Layer_1').css('cursor', 'url("data:image/svg+xml,%3Csvg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' x=\'0px\' y=\'0px\' width=\'20px\' height=\'20px\' viewBox=\'0 0 512 512\'%3E%3Cpath fill=\'currentColor\' d=\'M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z\'%3E%3C/path%3E%3C/svg%3E") 0 20, pointer');
            }
            //color.toHexString(); // #ff0000
        },
    });


    $('#color_picker_panda').spectrum({
        type: "flat",
        showPaletteOnly: "true",
        showInput: "false",
        showInitial: "true",
        hideAfterPaletteSelect: "true",
        palette: [
            ['#865336', '#653720', '#c9a593', '#d6b9ab', '#c9928b'],
            ['#8ecef1', '#8bc43f', '#006738', '#fcdb00', '#bf2226'],
            ['#ed2829', '#1f191b'],
            ['#FFFFFF']
        ],
        change: function (color) {           
            if (color.toHex() != "ffffff") {
                var fill = " fill='%23" + color.toHex() + "'";
                $('#Layer_2').css('cursor', 'url("data:image/svg+xml,%3Csvg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' x=\'0px\' y=\'0px\' width=\'20px\' height=\'20px\' viewBox=\'0 0 512 512\'%3E%3Cpath ' + fill + ' d=\'M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z\'%3E%3C/path%3E%3C/svg%3E") 0 20, pointer');
            } else {
                $('#Layer_2').css('cursor', 'url("data:image/svg+xml,%3Csvg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' x=\'0px\' y=\'0px\' width=\'20px\' height=\'20px\' viewBox=\'0 0 512 512\'%3E%3Cpath fill=\'currentColor\' d=\'M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z\'%3E%3C/path%3E%3C/svg%3E") 0 20, pointer');
            }
            //color.toHexString(); // #ff0000
        },
    });
    
    $('#color_picker_castle').spectrum({
        type: "flat",
        color: "#000000",
        showPaletteOnly: "true",
        showInput: "false",
        showInitial: "true",
        hideAfterPaletteSelect: "true",        
        change: function (color) {           
            if (color.toHex() != "ffffff") {
                var fill = " fill='%23" + color.toHex() + "'";
                $('#Layer_5').css('cursor', 'url("data:image/svg+xml,%3Csvg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' x=\'0px\' y=\'0px\' width=\'20px\' height=\'20px\' viewBox=\'0 0 512 512\'%3E%3Cpath ' + fill + ' d=\'M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z\'%3E%3C/path%3E%3C/svg%3E") 0 20, pointer');
            } else {
                $('#Layer_2').css('cursor', 'url("data:image/svg+xml,%3Csvg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' x=\'0px\' y=\'0px\' width=\'20px\' height=\'20px\' viewBox=\'0 0 512 512\'%3E%3Cpath fill=\'#000000\' d=\'M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z\'%3E%3C/path%3E%3C/svg%3E") 0 20, pointer');
            }
            //color.toHexString(); // #ff0000
        },
    });


    $('#color_picker_diver').spectrum({
        type: "flat",
        showPaletteOnly: "true",
        showInput: "false",
        showInitial: "true",
        hideAfterPaletteSelect: "true",
        palette: [
            ['#feabbd', '#ff598f', '#4b2369', '#003875', '#004b6b'],
            ['#0362b6', '#10aeed', '#8ecef1', '#c0e4e4', '#e17a01'],
            ['#ff9f00', '#ffc300', '#f9d235', '#fff669', '#eae1b8'],
            ['#FFFFFF']
        ],
        change: function (color) {
            console.log(color.toHex());
            if (color.toHex() != "ffffff") {
                var fill = " fill='%23" + color.toHex() + "'";
                $('#Layer_3').css('cursor', 'url("data:image/svg+xml,%3Csvg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' x=\'0px\' y=\'0px\' width=\'20px\' height=\'20px\' viewBox=\'0 0 512 512\'%3E%3Cpath ' + fill + ' d=\'M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z\'%3E%3C/path%3E%3C/svg%3E") 0 20, pointer');
            } else {
                $('#Layer_3').css('cursor', 'url("data:image/svg+xml,%3Csvg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' x=\'0px\' y=\'0px\' width=\'20px\' height=\'20px\' viewBox=\'0 0 512 512\'%3E%3Cpath fill=\'currentColor\' d=\'M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z\'%3E%3C/path%3E%3C/svg%3E") 0 20, pointer');
            }
            //color.toHexString(); // #ff0000
        },
    });

    $('#color_picker_land').spectrum({
        type: "flat",
        showPaletteOnly: "true",
        showInitial: "true",
        hideAfterPaletteSelect: "true",
        /*showPaletteOnly: "true",
        showInput: "false",
        showInitial: "true",
        hideAfterPaletteSelect: "true",*/
        palette: [
            ['#bf9456', '#90441d', '#f2dbb6', '#d2eef9', '#8fd0f1'],
            ['#FFFFFF']
        ],
        change: function (color) {
            console.log(color.toHex());
            if (color.toHex() != "ffffff") {
                var fill = " fill='%23" + color.toHex() + "'";
                $('#Layer_4').css('cursor', 'url("data:image/svg+xml,%3Csvg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' x=\'0px\' y=\'0px\' width=\'20px\' height=\'20px\' viewBox=\'0 0 512 512\'%3E%3Cpath ' + fill + ' d=\'M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z\'%3E%3C/path%3E%3C/svg%3E") 0 20, pointer');
            } else {
                $('#Layer_4').css('cursor', 'url("data:image/svg+xml,%3Csvg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' x=\'0px\' y=\'0px\' width=\'20px\' height=\'20px\' viewBox=\'0 0 512 512\'%3E%3Cpath fill=\'currentColor\' d=\'M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z\'%3E%3C/path%3E%3C/svg%3E") 0 20, pointer');
            }
        },
        hide: function (color) {
            color.toHexString(); // #ff0000
        }
    });

    $('#undo').on('click', function (e) {
        $('.clicked').removeAttr('style');
        $(this).prop('disabled', true);
    });

    $('#clear').on('click', function (e) {
        $('#color-picker').spectrum("set", 'white');
        $('#color_picker_panda').spectrum("set", 'white');
    });

    $('#Layer_1').on('click', function (e) {
        var t = $("#color-picker").spectrum("get"),
            current_color = t.toHexString(),
            iscrown = $(e.target).hasClass('crown') ? true : false;

        $('.clicked').removeClass('clicked');
        $(e.target).addClass('clicked');
        $('#undo').prop('disabled', false);

        if (e.target.nodeName == 'path' || e.target.nodeName == 'polygon') {
            $(e.target).css('fill', current_color);
            if (iscrown) {
                $('.crown').css('fill', current_color);
            }
        } else {
            $(e.target).css('background-color', current_color);
        }

    });

    $('#Layer_2').on('click', function (e) {
        var t = $("#color_picker_panda").spectrum("get"),
            current_color = t.toHexString();

        $('.clicked').removeClass('clicked');
        $(e.target).addClass('clicked');
        $('#undo').prop('disabled', false);

        console.log(e.target.nodeName);

        if (e.target.nodeName == 'path' || e.target.nodeName == 'polygon' || e.target.nodeName == 'use' || e.target.nodeName == 'rect') {
            $(e.target).css('fill', current_color);
        } else {
            $(e.target).css('background-color', current_color);
        }

    });

    $('#Layer_3').on('click', function (e) {
        var t = $("#color_picker_diver").spectrum("get"),
            current_color = t.toHexString();

        $('.clicked').removeClass('clicked');
        $(e.target).addClass('clicked');
        $('#undo').prop('disabled', false);

        if (e.target.nodeName == 'path' || e.target.nodeName == 'polygon' || e.target.nodeName == 'use' || e.target.nodeName == 'rect') {
            $(e.target).css('fill', current_color);
        } else {
            $(e.target).css('background-color', current_color);
        }

    });

    $('#Layer_4').on('click', function (e) {
        var t = $("#color_picker_land").spectrum("get"),
            current_color = t.toHexString();

        $('.clicked').removeClass('clicked');
        $(e.target).addClass('clicked');
        $('#undo').prop('disabled', false);

        if (e.target.nodeName == 'path' || e.target.nodeName == 'polygon' || e.target.nodeName == 'use' || e.target.nodeName == 'rect' || e.target.nodeName == 'circle') {
            $(e.target).css('fill', current_color);
        } else {
            $(e.target).css('background-color', current_color);
        }

    });
    
    $('#Layer_5').on('click', function (e) {
        var t = $("#color_picker_castle").spectrum("get"),
            current_color = t.toHexString();

        $('.clicked').removeClass('clicked');
        $(e.target).addClass('clicked');
        $('#undo').prop('disabled', false);

        if (e.target.nodeName == 'path' || e.target.nodeName == 'polygon' || e.target.nodeName == 'use' || e.target.nodeName == 'rect' || e.target.nodeName == 'circle') {
            $(e.target).css('fill', current_color);
        } else {
            $(e.target).css('background-color', current_color);
        }

    });
});


function triggerDownload(imgURI) {
    var evt = new MouseEvent('click', {
        view: window,
        bubbles: false,
        cancelable: true
    });

    var a = document.createElement('a');
    a.setAttribute('download', 'Prestige_10-2.png');
    a.setAttribute('href', imgURI);
    a.setAttribute('target', '_blank');

    a.dispatchEvent(evt);
}


function uploadEx() {
    var canvas = document.getElementById("canvas");
    var dataURL = canvas.toDataURL("image/png");
    document.getElementById('hidden_data').value = dataURL;
    var fd = new FormData(document.forms["form1"]);

    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'upload_data.php', true);

    xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) {
            var percentComplete = (e.loaded / e.total) * 100;
           /* console.log(percentComplete + '% uploaded');
            console.log('Succesfully uploaded');*/
        }
    };

    xhr.onload = function () {
        /*console.log('https://netadvance.space/naya-color/' + xhr.responseText);
        console.log(xhr);*/
        FB.ui({
          method: 'share',
          href: 'http://naya.bg/game/' + xhr.responseText,
        }, function(response){});
       
    };
    xhr.send(fd);
}